import React, { Fragment, useState } from "react";
import Translator from "Languages/Utility/Translator";
import AuthHeader from "../components/AuthHeader";
import Input from "Components/Input/Input";
import MuiButton from "Components/MuiButton/MuiButton";
import { useDispatch, useSelector } from "react-redux";
import { useSetState } from "Helpers/Hooks";
import { authSingUp } from "Stores/actions";
import showNotify from "Helpers/Notify";
import { convertToEnglishNumber } from "Helpers/convertToEnglishNumber";
// import { withGoogleReCaptcha } from "react-google-recaptcha-v3";
import { useTranslation } from "react-i18next";
import { push } from "Helpers/History";
import { store } from "Helpers/LocalStorage";
// import checkBoxCheckedIcon from "Assets/svg/icon/checkbox-checked.svg";
// import checkBoxIcon from "Assets/svg/icon/checkbox.svg";
// import { ReactSVG } from "react-svg";
import { Checkbox, useTheme } from "@material-ui/core";
import ValidationFailed from "hoc/IntroLayout/ValidationFailed";

// function SignUp(props) {
function SignUp() {
  const { t } = useTranslation();
  const { direction } = useTheme();
  const dispatch = useDispatch();
  const [formValid, setFormValid] = useState(false);
  const [loading, setLoading] = useState(false);
  const [acceptRules, setAcceptRules] = useState(false);
  const { cwt } = useSelector((state) => ({
    cwt: state.settings.cwt,
  }));
  const [state, setState] = useSetState({
    phone: {
      value: "",
      validation: {
        required: true,
        isNumeric: true,
        isPhoneSignUp: true,
      },
    },
  });

  const onReturnLogin = () => push("/");

  const setValue = (name, value, validation) => {
    setState({ [name]: { value: value } });
    setFormValid(validation);
  };

  const onUserSignUp = async (e) => {
    e.preventDefault();
    if (cwt && cwt.Active && cwt.IsShowRegister) {
      const { phone } = state;
      const enPhone = convertToEnglishNumber(phone.value);
      let phoneWithCode = enPhone;
      if (enPhone.charAt(0) === "0") phoneWithCode = enPhone.replace("0", "");
      if (formValid && cwt && cwt.update && cwt.Active && cwt.IsShowRegister) {
        try {
          store("PNumber", phoneWithCode);
          const token = ""; // await props.googleReCaptchaProps?.executeRecaptcha();
          setLoading(true);
          const type = 2; //mobile
          const data = {
            Account: phoneWithCode,
            Type: type,
            keyCap: token,
            CountryId: 1,
          };
          await dispatch(authSingUp(data));
          setLoading(false);
        } catch (e) {
          setLoading(false);
        }
      } else {
        showNotify({
          text: t("invalidNumber"),
          customClass: "error",
        });
      }
    } else {
      push("/");
    }
  };

  const onAcceptChange = (e) => {
    setAcceptRules(e.target.checked);
  };

  return (
    <div className="signIn">
      <Fragment>
        <ValidationFailed
          forcedCondition={
            cwt && cwt.update && cwt.Active && !cwt?.IsShowRegister
          }
        />
        <AuthHeader
          title={t("button_signup")}
          description={t("EnterMobileNumber")}
        />
        <form onSubmit={onUserSignUp} className="pt-5">
          <div className="authForm ">
            <Input
              className="phone"
              setValue={setValue.bind(this)}
              value={state.phone.value}
              name="phone"
              validation={state.phone.validation}
              label={<Translator id="input_phone" />}
              type="text"
              fullWidth
              helperText={"mobileExample"}
              maxlength="11"
            />
          </div>
          <div
            className={`privacy_checkbox ${direction === "rtl" ? "text-right" : "text-left"}`}
          >
            <Checkbox
              // size={"small"}
              id="select-all-checkbox"
              // checkedIcon={<ReactSVG src={checkBoxCheckedIcon} />}
              // icon={<ReactSVG src={checkBoxIcon} />}
              className="mt-2"
              checked={acceptRules}
              onChange={onAcceptChange}
            />
            <p>
              <a href="/privacy" target="_blank">
                <u>{t("acceptance_rules_p1")}</u>
              </a>{" "}
              {t("acceptance_rules_p2")}
            </p>
          </div>
          <div className="d-flex justify-content-center my-3">
            <MuiButton
              type="submit"
              loading={loading}
              className="w-100"
              color="primary"
              title={<Translator id="button_send_code" />}
              disabled={
                !acceptRules ||
                (cwt && cwt.update && cwt.Active && !cwt?.IsShowRegister)
              }
            />
          </div>
          <div className="d-flex justify-content-center ">
            <MuiButton
              className="link"
              onClick={onReturnLogin}
              title={<Translator id="button_return_login" />}
            />
          </div>
        </form>
      </Fragment>
    </div>
  );
}

export default SignUp;
// export default withGoogleReCaptcha(SignUp);
